// extracted by mini-css-extract-plugin
module.exports = {"blue":"C19_4_PromotionalResearch_blue__BbW04","title":"C19_4_PromotionalResearch_title__6Nwmi","defaultbgColor":"C19_4_PromotionalResearch_defaultbgColor__Ie1Rq"};